import { Box, Typography } from "@mui/material";

type Props = {
  title: string;
  description?: string;
};

const PageTitle = ({ title, description }: Props) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        {title}
      </Typography>
      {description && (
        <Typography variant="body1" color="text.secondary">
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default PageTitle;
